import '../App.css'
import React, {useState} from 'react';
import {Col, Layout, Row} from "antd";
import {Content} from "antd/es/layout/layout";
import {Route, Routes, useLocation} from "react-router-dom";
import InputForm from './form.js';
import About from './about.js'
import Example from './example.js'
import Help from './help.js'
import References from './references.js'
import MoleStarBis from "./molstar1";
import logo from "../assets/cocomaps.png"
import MainMenu from "./menu/mainMenu";
import ResultMenu from "./menu/resultMenu";

export default function Home() {

    const [menuIsVisible, setMenuIsVisible] = useState(true);
    const [resultTitle, setResultTitle] = useState("");
    const [resultPath, setResultPath] = useState("");

    const location = useLocation();

    return (
        <>
            <Layout className="layout">
                <Content>
                    <>
                        <Row style={{backgroundColor: 'white', padding: '0px 0px 0px 28px', borderBottom: '1px solid #e5e5e5'}}>
                            <Col>
                                <div style={{top: '9px', position: 'relative'}}>
                                    <a href={"/BioTools/cocomaps2"}><img src={logo} alt='Cocomaps 2.0' height={25}></img></a>
                                </div>
                            </Col>
                            {menuIsVisible ? (
                                <MainMenu/>
                            ) : (
                                <ResultMenu resultTitle={resultTitle} resultPath={resultPath}/>
                            )}
                        </Row>
                    </>

                    <div className={location.pathname !== "/mols" ? 'site-layout-content' : 'result-layout-content'}>
                        <Routes>
                            <Route path="/" element={<InputForm/>}></Route>
                            <Route path="/about" element={<About/>}></Route>
                            <Route path="/example" element={<Example/>}></Route>
                            <Route path="/help" element={<Help/>}></Route>
                            <Route path="/references" element={<References/>}></Route>
                            <Route path="/mols" element={<MoleStarBis setMenuIsVisible={setMenuIsVisible} setResultTitle={setResultTitle} setResultPath={setResultPath}/>}></Route>
                        </Routes>
                    </div>

                </Content>
            </Layout>
        </>
    );
}
